import { render, staticRenderFns } from "./dj_news_xq.vue?vue&type=template&id=b1f666ba&"
import script from "./dj_news_xq.vue?vue&type=script&lang=js&"
export * from "./dj_news_xq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports